import { useState } from "react";

import * as Papa from "papaparse";
import { useDispatch } from "react-redux";

import { showSuccessToast, showErrorToast } from "app/actions/toast_actions";
import { getToastItemComponent } from "app/components/React/Toast/ToastItem";
import { translate } from "app/filters/i18nFilter";

import { ONE } from "../../components/Header/constants";
import { parsingNotifications } from "../../constants/texts";
import { activationTracking } from "../../services/tracking";

export const useParsing = (limit: number, selectedKeywords: string[]) => {
    const [parsedData, setParsedData] = useState<string[]>(null);
    const [isParsing, setIsParsing] = useState(false);
    const track = activationTracking.home;

    const dispatch = useDispatch();

    const parse = (file: File) => {
        try {
            setIsParsing(true);
            const parsedDomains = new Set(selectedKeywords);
            const fileName = file?.name;

            let isOutOfLimit = false;
            let counter = 0;

            Papa.parse(file, {
                step: (stepData: Papa.ParseStepResult<string[]>, parser: Papa.Parser) => {
                    if (counter >= limit) {
                        isOutOfLimit = true;
                        parser.abort();
                    }

                    if (stepData?.data?.length !== ONE) {
                        parser.abort();
                    }

                    const current = stepData.data[0];

                    if (!parsedDomains.has(current)) {
                        counter++;
                        parsedDomains.add(current);
                    }
                },

                complete: ({ meta }) => {
                    setIsParsing(false);

                    if (!isOutOfLimit && meta?.aborted) {
                        dispatch(
                            showErrorToast(
                                getToastItemComponent({
                                    text: translate(parsingNotifications.failed),
                                    showCloseIcon: true,
                                }),
                            ),
                        );
                        return;
                    }

                    if (isOutOfLimit) {
                        dispatch(
                            showErrorToast(
                                getToastItemComponent({
                                    text: translate(parsingNotifications.outOfLimit, {
                                        number: counter,
                                    }),
                                }),
                            ),
                        );

                        setParsedData([...parsedDomains]);

                        return;
                    }

                    dispatch(
                        showSuccessToast(
                            getToastItemComponent({
                                text: translate(parsingNotifications.success, {
                                    count: counter,
                                    fileName,
                                }),
                            }),
                        ),
                    );

                    track.trackImportCSVFinish(parsedDomains.size);

                    setParsedData([...parsedDomains]);
                },
            });
        } catch (e) {
            setIsParsing(false);
        }
    };

    return { parsedData, isParsing, parse };
};
